<template>
  <svg width="887" height="1573" viewBox="0 0 887 1573" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.1" filter="url(#filter0_f_7284_4385)">
      <rect x="414" y="414" width="745" height="745" rx="320" fill="#EB883B"/>
    </g>
    <defs>
      <filter id="filter0_f_7284_4385" x="0" y="0" width="1573" height="1573" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="207" result="effect1_foregroundBlur_7284_4385"/>
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>
